import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ErrorBoundary from './components/ErrorBoundary';
import { ToastProvider } from './context/ToastContext';
import StorageUtils from './components/StorageUtils';
import Header from './components/Header';
import Footer from './components/Footer';
import MobileBottomNav from './components/MobileBottomNav';
import HomePage from './pages/HomePage';
import ShopPage from './pages/ShopPage';
import ProductPage from './pages/ProductPage';
import VendorPage from './pages/VendorPage';
import CartPage from './pages/CartPage';
import WishlistPage from './pages/WishlistPage';
import AccountPage from './pages/AccountPage';
import CheckoutPage from './pages/CheckoutPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import TrackOrderPage from './pages/TrackOrderPage';
import PartnersPage from './pages/PartnersPage';
import WorkWithUsPage from './pages/WorkWithUsPage';
import FAQPage from './pages/FAQPage';
import TeamPage from './pages/TeamPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import PlaceholderPage from './pages/PlaceholderPage';

function Layout({ children }: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen flex flex-col bg-[var(--background)] text-[var(--foreground)]">
      <Header />
      <div className="flex-1 pb-20 md:pb-0">{children}</div>
      <Footer />
      <MobileBottomNav />
    </div>
  );
}

export default function App() {
  return (
    <ErrorBoundary>
      <ToastProvider>
        <StorageUtils />
        <BrowserRouter>
          <Layout>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/shop" element={<ShopPage />} />
              <Route path="/show_now" element={<ShopPage />} />
              <Route path="/product/:id" element={<ProductPage />} />
              <Route path="/vendor/:vendorId" element={<VendorPage />} />
              <Route path="/cart" element={<CartPage />} />
              <Route path="/wishlist" element={<WishlistPage />} />
              <Route path="/account" element={<AccountPage />} />
              <Route path="/checkout" element={<CheckoutPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/track" element={<TrackOrderPage />} />
              <Route path="/partners" element={<PartnersPage />} />
              <Route path="/work-with-us" element={<WorkWithUsPage />} />
              <Route path="/team" element={<TeamPage />} />
              <Route path="/faqs" element={<FAQPage />} />
              <Route path="/privacy" element={<PrivacyPolicyPage />} />
              <Route path="/orders" element={<PlaceholderPage />} />
              <Route path="/returns" element={<PlaceholderPage />} />
              <Route path="/recently-viewed" element={<PlaceholderPage />} />
              <Route path="*" element={<PlaceholderPage />} />
            </Routes>
          </Layout>
        </BrowserRouter>
      </ToastProvider>
    </ErrorBoundary>
  );
}
